import React, { useEffect, useRef } from "react"
import { useNavigate, Link } from "react-router-dom"

const Error: React.FC = () => {

		const biscoffBarRef = useRef<HTMLImageElement | null>(null)
		const normalBarRef = useRef<HTMLImageElement | null>(null)
	const navigate = useNavigate()
	useEffect(() => {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "smooth",
		})
	}, [])

	return (
		<>
			<div className="relative bg-hero">
								<div className="grid md:grid-cols-2 items-center justify-items-center lg:h-[667px] max-w-[1324px] mx-auto">
									<div className="relative sm:hidden bg-[url('/src/bgimages/header-hero-mobile.png')] bg-no-repeat w-full bg-center bg-cover h-[300px] ">
										<img src={process.env.PUBLIC_URL + "/images/header-mobile.png"} alt="TREK Protein Oat Bar" className="mx-auto block sm:hidden" />
									</div>
									<div className="w-full lg:max-w-[100%] mx-auto px-4  pb-12 md:p-12 relative z-[5]">
										<h1 className=" text-white uppercase pt-12">Jetzt probieren - ganz ohne Risiko.</h1>
										<p className="text-white lg:max-w-[90%] font-AmsiRegular">Vom 01. September bis 31. Dezember bekommst du Dein Geld für eine Packung TREK Protein Oat Bars 150g zurück.</p>
										<div className=" grid grid-cols-2 md:flex  items-center gap-x-2 md:gap-x-6 mt-6 lg:mt-12 ">
											<Link to="/" className="btn btn-primary justify-self-center">
												Zurück zur Aktion
											</Link>
										</div>
									</div>
									<div className="relative bg-[url('/src/bgimages/bg-hero-right.png')] bg-no-repeat w-full bg-center bg-cover h-[300px] md:h-[667px] before-hero hidden md:block">
									<img src={process.env.PUBLIC_URL + "/images/cashback-hero.png"} alt="Cashback Geld-zurück-Siegel" className="mx-auto hidden md:block absolute -left-16 h-[40%] top-44" />
										<img ref={biscoffBarRef} src={process.env.PUBLIC_URL + "/images/trek-biscoff-riegel.png"} alt="TREK Protein Oat Bar Biscoff" className="mx-auto hidden md:block absolute left-32" />
										<img ref={normalBarRef} src={process.env.PUBLIC_URL + "/images/trek-normal-riegel.png"} alt="TREK Protein Oat Bar" className="mx-auto hidden md:block absolute bottom-4 left-32" />
									</div>
								</div>
							</div>
				<h2 className="mb-4 mt-12  font-AmsiBlack uppercase text-blue lg:mb-0 max-w-[90%] md:max-w-full mx-auto">
					Hier scheint etwas schief gelaufen zu sein ....
				</h2>		
	
			<div className="py-10 pt-1 text-center text-xl text-errorred mt-6 md:mt-24">
				<button onClick={() => navigate(-1)} className="btn-primary-yellow">
					Zurück
				</button>
			</div>
		</>
	)
}
export default Error
